import { render, staticRenderFns } from "./SettingsMarketplace.vue?vue&type=template&id=7dde7971&"
import script from "./SettingsMarketplace.vue?vue&type=script&lang=js&"
export * from "./SettingsMarketplace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports